"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _generalStore = require("general-store");

var _TimelineEventsDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineEventsDependency"));

var _SubjectDependency = _interopRequireDefault(require("crm_ui/flux/dependencies/SubjectDependency"));

var _TimelineOverridableFavoriteEventsDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineOverridableFavoriteEventsDependency"));

var _TimelineStatusDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineStatusDependency"));

var _TimelineDateRangeDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineDateRangeDependency"));

var _immutable = require("immutable");

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _Timeline = _interopRequireDefault(require("crm_ui/timeline/components/config/Timeline"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _TimelineOverrideFavoriteEventDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineOverrideFavoriteEventDependency"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _TimelineTeamsFilterDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineTeamsFilterDependency"));

var _TimelineUsersFilterDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineUsersFilterDependency"));

var _TimelineTextFilterDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineTextFilterDependency"));

var _PinnedEngagementDependency = _interopRequireDefault(require("crm_ui/pinnedEngagements/dependencies/PinnedEngagementDependency"));

var _EngagementType = _interopRequireDefault(require("crm_ui/engagements/EngagementType"));

var _ErrorBoundary = _interopRequireDefault(require("customer-data-objects-ui-components/ErrorBoundary"));

var _ProfileTimelineErrorMessage = _interopRequireDefault(require("crm_ui/timeline/components/config/ProfileTimelineErrorMessage"));

var _customErrorTypes = _interopRequireDefault(require("crm_ui/constants/customErrorTypes"));

var TimelineWrapper =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelineWrapper, _PureComponent);

  function TimelineWrapper() {
    (0, _classCallCheck2.default)(this, TimelineWrapper);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineWrapper).apply(this, arguments));
  }

  (0, _createClass2.default)(TimelineWrapper, [{
    key: "render",
    value: function render() {
      if (!this.props.timelineFavoriteEvents) {
        return null;
      }

      var _this$props = this.props,
          pinnedEngagement = _this$props.pinnedEngagement,
          passthruProps = (0, _objectWithoutProperties2.default)(_this$props, ["pinnedEngagement"]);
      return _react.default.createElement(_ErrorBoundary.default, {
        boundaryName: "TimelineWrapper_TimelineErrorState",
        ErrorComponent: _ProfileTimelineErrorMessage.default,
        errorProps: {
          errorMessageType: _customErrorTypes.default.TIMELINE,
          objectType: this.props.objectType
        }
      }, _react.default.createElement(_Timeline.default, (0, _extends2.default)({}, passthruProps, {
        hasPinnedEngagement: !!pinnedEngagement
      })));
    }
  }]);
  return TimelineWrapper;
}(_PureComponent2.default);

TimelineWrapper.propTypes = {
  futureEvents: _propTypes.default.instanceOf(_immutable.Set),
  dateRange: _propTypes.default.instanceOf(_immutable.Map),
  objectType: _ObjectTypesType.default.isRequired,
  subject: _SubjectType.default,
  subjectId: _propTypes.default.string.isRequired,
  timelineFavoriteEvents: _propTypes.default.instanceOf(_immutable.List),
  timelineStatus: _propTypes.default.instanceOf(_immutable.Map),
  profileStartTime: _propTypes.default.number,
  pinnedEngagement: _EngagementType.default
};

var _default = (0, _generalStore.connect)({
  dateRange: _TimelineDateRangeDependency.default,
  events: _TimelineEventsDependency.default,
  subject: _SubjectDependency.default,
  timelineFavoriteEvents: _TimelineOverridableFavoriteEventsDependency.default,
  selectedTeams: _TimelineTeamsFilterDependency.default,
  selectedUsers: _TimelineUsersFilterDependency.default,
  timelineStatus: _TimelineStatusDependency.default,
  favoriteEventOverride: _TimelineOverrideFavoriteEventDependency.default,
  searchText: _TimelineTextFilterDependency.default,
  pinnedEngagement: _PinnedEngagementDependency.default
})(TimelineWrapper);

exports.default = _default;
module.exports = exports.default;